module.exports = __webpack_public_path__ + "img/img0.5d49a598.jpg";